import { render } from "./keywordSuggession.vue?vue&type=template&id=50638f72&scoped=true"
import script from "./keywordSuggession.vue?vue&type=script&lang=js"
export * from "./keywordSuggession.vue?vue&type=script&lang=js"

import "./keywordSuggession.vue?vue&type=style&index=0&id=50638f72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50638f72"]])

export default __exports__